import Component from "@ember/component";
import { classNames } from "@ember-decorators/component";
import CommuniteqAdminNotice from "../../components/communiteq-admin-notice";

@classNames("below-site-header-outlet", "show-admin-notice")
export default <template><CommuniteqAdminNotice /></template>
